import { Link, useParams } from "react-router-dom"
import { Alert, Box, Button } from "@mui/material"
import { GoBack } from "@/core/components"
import { ChannelHeader } from "../components/channels/channelHeader"
import { ChannelEventLogsSection } from "../components/channels/channelEventLogsSection"

import { PlacementsTable } from "../components/placements/placementsTable"
import type { TemplateWriteAccess } from "../hooks/useVersionDraft"
import { isChannelId, placementPath } from "../utils/placementDraft"

const DetailedChannelPage = ({
  canRead = false,
  ...access
}: TemplateWriteAccess & { canRead?: boolean }) => {
  const { channelId } = useParams()

  if (!isChannelId(channelId)) {
    return <Alert severity="error">Некорректный ID канала</Alert>
  }

  return (
    <Box width="100%">
      <GoBack />
      <ChannelHeader key={channelId} channelId={channelId} />
      <ChannelEventLogsSection channelId={channelId} />
      {canRead && !access.readOnly && access.canWrite === true && (
        <Button
          component={Link}
          to={`${placementPath("new")}?channelId=${encodeURIComponent(channelId)}`}
        >
          Создать размещение
        </Button>
      )}
      {canRead && <PlacementsTable channelId={channelId} {...access} />}
    </Box>
  )
}

export default DetailedChannelPage
